import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-10 py-16">
      <div className="overline text-safety">Our mission</div>
      <h1 className="mt-2 font-display font-black text-5xl lg:text-6xl tracking-tighter text-forest leading-none">
        Every office deserves<br/>a second life.
      </h1>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
        <p className="text-base leading-relaxed text-foreground/90">
          Furniture Exchange is the UK's dedicated marketplace connecting offices closing down
          with buyers and specialist commercial removal firms. We exist because thousands of
          tonnes of perfectly usable desks, chairs and cabinets end up in landfill every year —
          and it's ridiculous.
        </p>
        <p className="text-base leading-relaxed text-foreground/90">
          Post a single desk or a whole floor. Get connected with same-day removals. Buy quality
          office kit at a fraction of retail. We keep the marketplace clean, the fees fair, and
          the sustainability real: 98% of listed items are rehomed or recycled.
        </p>
      </div>
      <div className="mt-10">
        <Button asChild className="rounded-none bg-forest hover:bg-forest-800 text-white h-12 px-8" data-testid="about-cta">
          <Link to="/sell">Post a listing →</Link>
        </Button>
      </div>
    </div>
  );
}
